module.exports = __webpack_public_path__ + "img/v-town-capsule.4a90d869.png";